import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import courseList from "../Data/courseList";
import { div } from "framer-motion/client";

const CourseDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const course = courseList.find((c) => c.id === id);

  if (!course) return <div className="text-center py-10 text-gray-500">Course Not Found</div>;

  return (
    <div className="py-10">

   
    <div className=" min-h-screen py-16 px-4">
      {/* Back Button */}
      <div className="max-w-6xl mx-auto mb-6">
        <button
          onClick={() => navigate(-1)}
          className="text-purple-600 hover:text-purple-800 font-medium flex items-center"
        >
          <span className="text-xl mr-1">←</span> Back
        </button>
      </div>

      {/* Header Section */}
      <div className="max-w-6xl mx-auto bg-white shadow-xl rounded-3xl p-8 flex flex-col md:flex-row items-center justify-between">
        {/* Left: Text */}
        <div className="flex-1">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">{course.title}</h1>
          <p className="text-gray-600 mb-4 text-lg">{course.shortDesc}</p>

          <div className="flex flex-wrap gap-4 mb-4 text-sm">
            <span className="bg-yellow-100 text-yellow-700 px-3 py-1 rounded-full font-medium">⏱ {course.duration}</span>
            <span className="bg-green-100 text-green-700 px-3 py-1 rounded-full font-medium">💰 {course.price}</span>
            <span className="bg-blue-100 text-blue-700 px-3 py-1 rounded-full font-medium">📘 {course.details.length} Modules</span>
          </div>

          <button className="bg-purple-600 text-white px-6 py-3 rounded-lg font-semibold shadow hover:bg-purple-700">
            Start subscription
          </button>

          <p className="text-gray-500 text-sm mt-2">Cancel anytime. Access all content.</p>
        </div>

        {/* Right: Image */}
        <div className="w-72 h-72 mt-8 md:mt-0">
          <img src={course.image} alt={course.title} className="w-full h-full object-contain rounded-2xl" />
        </div>
      </div>

      {/* What You'll Learn */}
      <div className="max-w-6xl mx-auto mt-12">
        <h2 className="text-2xl font-bold text-gray-800 mb-6">📚 What You'll Learn</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {course.details.map((item, index) => (
            <div key={index} className="bg-white shadow rounded-xl p-6">
              <div className="text-5xl font-bold text-purple-500 opacity-60 mb-2">{index + 1}</div>
              <p className="text-gray-700 font-medium">{item}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Highlights */}
      <div className="max-w-6xl mx-auto mt-12">
        <h2 className="text-2xl font-bold text-gray-800 mb-4">🌟 Highlights</h2>
        <ul className="list-disc ml-6 text-gray-700 space-y-2">
          {course.highlights.map((h, i) => (
            <li key={i}>{h}</li>
          ))}
        </ul>
      </div>
    </div>
     </div>
  );
};

export default CourseDetails;
